import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useAcceptTermsOfUse = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const fetchConfig = getFetchConfig({ method: FetchMethod.POST });
      const res = await fetch(`${APIBaseChronos}/api/terms-of-use/accept`, fetchConfig);

      if (!res.ok) {
        throw new Error('Failed to accept terms of use');
      }

      const data: { acceptedAt: string } = await res.json();
      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.User]);
      },
      onError: () => {
        toast.error('Failed to accept the terms of use. Please try again.');
      },
    },
  );
};
